import { Controller, LoggedUser, Tabs } from '@autoprog/core-client';

import C_Customers from '@modules/BillsCustomer/js/tabs/Customers';
import T_TabsCustomer from '@modules/BillsCustomer/tpl/tabs/customer.html';

import C_Providers from '@modules/BillsProvider/js/tabs/Providers';
import T_TabsProvider from '@modules/BillsProvider/tpl/tabs/provider.html';

import History from '@libs/History';

class BillsCtrl extends Controller {
	private tabs: Tabs;

	constructor(el: HTMLElement, data: any, params: any) {
		super(el);

		params = params || {};

		let defaultTab = params.tabs;

		const navElement = el.querySelector('.tabs-container') as HTMLElement;

		this.tabs = new Tabs({
			navElement,
			renderElement: el.querySelector('#page-content') as HTMLElement
		});

		const loggedUser = LoggedUser.getInstance();

		if (loggedUser.hasPermission('BILLS._CUSTOMERS.SHOW')) {
			defaultTab = defaultTab || 'customers';
		}

		this.tabs.add({
			name: 'Clients',
			id: 'customers',
			default: defaultTab === 'customers',
			permission: 'BILLS._CUSTOMERS.SHOW',
			controller: C_Customers,
			template: T_TabsCustomer
		});

		if (loggedUser.hasPermission('BILLS._PROVIDERS.SHOW')) {
			defaultTab = defaultTab || 'providers';
		}

		this.tabs.add({
			name: 'Fournisseurs',
			id: 'providers',
			default: defaultTab === 'providers',
			permission: 'BILLS._PROVIDERS.SHOW',
			controller: C_Providers,
			template: T_TabsProvider
		});

		let firstLoad = true;
		this.tabs.on('change', (data: { [key: string]: any }) => {
			if (firstLoad) {
				firstLoad = false;
			} else {
				History.getInstance().pushState(`#module/bills/${data.id}`);
			}
		});
	}

	public destructor() { }
}

export default BillsCtrl;
